import React from 'react';
import PropTypes from 'prop-types';

function Centrify({ children }) {
  return (
    <div style={{ height: '100%', width: '100%', display: 'flex' }}>
      {children}
    </div>
  );
}

Centrify.propTypes = {
  children: PropTypes.any.isRequired,
};

export default Centrify;
